/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { getComponentZoneLayout } from "cms/components/components/component";
import { InfoBoxComponentDisplay } from "cms/components/components/info-box/display";
import { InfoboxComponentEditor } from "cms/components/components/info-box/edit";

const InfoBoxComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <InfoBoxComponentDisplay />,
        editComponent: <InfoboxComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

InfoBoxComponent.displayName = "InfoBoxComponent";
export { InfoBoxComponent };
